import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api/client";
import { useAuth } from "./AuthContext";

const BillingStatusContext = createContext(null);

export function BillingStatusProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState("ok");
  const [usagePct, setUsagePct] = useState(0);

  const refresh = useCallback(() => {
    if (!user) return;
    api.get("/billing/wallet")
      .then(r => { setStatus(r.data.status || "ok"); setUsagePct(r.data.usage_pct || 0); })
      .catch(() => {});
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BillingStatusContext.Provider value={{ status, usagePct, refresh }}>
      {children}
    </BillingStatusContext.Provider>
  );
}

export const useBillingStatus = () => useContext(BillingStatusContext);
